const components: Record<string, () => Promise<unknown>> = {
    'sp-count-up': () => import('./components/count-up/count-up.component.js'),
    // Add more components here
};

// Try loading components that are in the DOM
function loadUsedComponents() {
    for (const tag in components) {
        if (customElements.get(tag)) continue;
        if (document.querySelector(tag)) {
            components[tag]().catch(err => console.error(`Failed to load <${tag}>`, err));
        }
    }
}

// Watch DOM for any new tags
const observer = new MutationObserver(() => loadUsedComponents());
observer.observe(document.body, { childList: true, subtree: true });

// Initial scan
loadUsedComponents();